<div class="title">Services</div>

<div class="services_container">
  <div class="service_button" (click)="print_command()">Printer</div>

  <div class="service_button" (click)="cash_drawer()">Cash Drawer</div>
</div>
